//import { useNavigate } from "react-router-dom";

import {
  checkAutoLogin,
  formatError,
  login,
  loginSc,
  saveTokenInLocalStorage,
  signOut,
  signUp,
  signUpSC,
  authApi,
} from "../../services/AuthService";
import {userRoleList} from "../../utils/constants";
import {technicianApi, userApi} from "../../services/technicianService";
import {socket} from "../../socket/socket";
import {
  showToastModal,
  ShowWelcomeModal,
} from "../../jsx/components/shared/ToastModalSwal";

export const SIGNUP_CONFIRMED_ACTION = "[signup action] confirmed signup";
export const SIGNUP_FAILED_ACTION = "[signup action] failed signup";
export const LOGIN_CONFIRMED_ACTION = "[login action] confirmed login";
export const PROFILE_UPDATED = "[profile action] confirmed update";

export const LOGIN_FAILED_ACTION = "[login action] failed login";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";
export const LOGOUT_ACTION = "[Logout action] logout action";

const refreshCurrentUser = async (queryClient, dispatch) => {
  await queryClient.refetchQueries({queryKey: ["getMe"], type: "active"});
  const cachedResponse = queryClient.getQueryData(["getMe"]);
  const refreshedUser =
    cachedResponse?.data?.data ?? cachedResponse?.data ?? cachedResponse;

  if (refreshedUser?.id) {
    dispatch(updateProfile(refreshedUser));
  }

  return refreshedUser;
};

export function signupAction(body, navigate, setStep) {
  return async (dispatch) => {
    try {
      const response = await signUp(body);
      const user = response.data.data.user;
      saveTokenInLocalStorage(response.data.data.token);
      /*  runLogoutTimer(
        dispatch,
        response.data.expiresIn * 1000
        //history,
      ); */
      if (user.selectedRole === userRoleList.CLIENT) {
        await ShowWelcomeModal({
          client: true,
          message:
            "Profitez de tout nos services à domicile et ajoutez votre première annonce.",
          thenCallback: () => {
            dispatch(confirmedSignupAction(user));
            navigate("/deposer-une-annonce");
          },
        });
        return;
      }

      dispatch(confirmedSignupAction(user));
      navigate("/");
    } catch (error) {
      const errorMessage = formatError(error.response.data);
      dispatch(signupFailedAction(errorMessage));
      setStep(false);
    }
  };
}

export function signupwithSCAction(body, navigate) {
  return (dispatch) => {
    signUpSC(body)
      .then((response) => {
        saveTokenInLocalStorage(response.data.data.token);
        /*  runLogoutTimer(
          dispatch,
          response.data.expiresIn * 1000
          //history,
        ); */
        dispatch(confirmedSignupAction(response.data.data.user));
        navigate("/");
        //history.push('/dashboard');
      })
      .catch((error) => {
        const errorMessage = formatError(error.response.data);
        dispatch(signupFailedAction(errorMessage));
      });
  };
}

export function Logout(navigate) {
  return async (dispatch) => {
    try {
      if (localStorage.getItem("token")) {
        await authApi.removeFcmToken();
        await signOut();
      }
    } catch (error) {
      // Local logout must still complete if the API is temporarily unavailable.
    } finally {
      socket.disconnect();
      socket.auth = {};
      localStorage.removeItem("token");
      localStorage.removeItem("helpclic_web_push_token");
      dispatch({type: LOGOUT_ACTION});
    }
  };
}

export function loginAction(email, password, navigate) {
  return (dispatch) => {
    login(email, password)
      .then((response) => {
        if (
          ![userRoleList.CLIENT, userRoleList.TECHNICIAN].includes(
            response.data.data.user.selectedRole,
          )
        ) {
          showToastModal({
            success: false,
            title: "Erreur de connexion",
            message:
              "Vous n'êtes pas autorisé à se connecter à cette application.",
            buttonTitle: "Ressayer",
            thenCallback: () => dispatch(Logout(navigate)),
          });
          return;
        }
        saveTokenInLocalStorage(response.data.data.token);
        /* runLogoutTimer(
                    dispatch,
                    response.data.expiresIn * 1000,
                    navigate,
                ); */
        dispatch(loginConfirmedAction(response.data.data.user));
        //
        //
        //
        //
        //return response.data;
        //return 'success';
        //history.push('/dashboard');
        navigate("/dashboard");
      })
      .catch((error) => {
        //
        //
        const errorMessage = formatError(error.response.data);
        dispatch(loginFailedAction(errorMessage));
      });
  };
}

export function updateProfileAction(
  {id, body, technicianID},
  navigate,
  queryClient,
) {
  const {
    companyName,
    taxRegistrationNumber,

    profileFile,
    profileImg,
    ...rest
  } = body;

  // Create FormData with the remaining fields (excluding specific keys)
  const newFormData = new FormData();
  Object.entries(rest).forEach(([key, value]) => {
    if (key !== "imageUri") {
      newFormData.append(key, value);
    }
  });

  const selectedProfileFile = profileFile || profileImg;
  if (selectedProfileFile) {
    newFormData.append("profileImg", selectedProfileFile);
  }

  return async (dispatch) => {
    try {
      // Update technician details
      await technicianApi.update({
        id: technicianID,
        body: {companyName, taxRegistrationNumber},
      });

      // Update user details
      await userApi.update({id, body: newFormData});
      dispatch(loadingToggleAction(false));

      const refreshedUser = await refreshCurrentUser(queryClient, dispatch);
      dispatch(loadingToggleAction(false));
      showToastModal({
        success: true,
        title: "Succès",
        buttonTitle: "Fermer",
        message: "Votre compte a été modifié avec succès.",
      });
      return refreshedUser;
    } catch (error) {
      // Handle errors
      // formatError({error: "Échec à la modification du profil"});
      showToastModal({
        success: false,
        title: "Échec de la modification",
        buttonTitle: "Réessayer",
        message:
          "Une erreur est survenue lors de la mise à jour de votre compte. Veuillez réessayer plus tard.",
      });
      dispatch(loadingToggleAction(false));
      throw error;
    }
  };
}
export function updateProfileClientAction({id, body}, navigate, queryClient) {
  // Create FormData with the remaining fields (excluding specific keys)
  const newFormData = new FormData();
  Object.entries(body).forEach(([key, value]) => {
    if (key !== "imageUri") {
      newFormData.append(key, value);
    }
  });

  return async (dispatch) => {
    try {
      // Update technician details

      // Update user details
      await userApi.update({id, body: newFormData});

      const refreshedUser = await refreshCurrentUser(queryClient, dispatch);
      dispatch(loadingToggleAction(false));
      showToastModal({
        success: true,
        title: "Succès",
        buttonTitle: "Fermer",
        message: "Votre compte a été modifié avec succès.",
      });
      return refreshedUser;
    } catch (error) {
      // Handle errors
      showToastModal({
        success: false,
        title: "Échec de la modification",
        buttonTitle: "Réessayer",
        message:
          "Une erreur est survenue lors de la mise à jour de votre compte. Veuillez réessayer plus tard.",
      });
      dispatch(loadingToggleAction(false));
      throw error;
    }
  };
}

export function verifAction({id, body}, navigate) {
  return async (dispatch) => {
    const response = await technicianApi.update({id, body});
    if (response?.status !== body.status) {
      throw new Error("Le statut du compte n'a pas été mis à jour.");
    }
    await checkAutoLogin(dispatch, navigate);
    return response;
  };
}

export function loginWithSc(email, user, signedBy, navigate) {
  return async (dispatch) => {
    let idToken;
    try {
      idToken = await user.getIdToken(true);
      const response = await loginSc({
        idToken,
        signedBy,
        imageUri: user.photoURL || "",
      });
        saveTokenInLocalStorage(response.data.data.token);
        /* runLogoutTimer(
                    dispatch,
                    response.data.expiresIn * 1000,
                    navigate,
                ); */
        dispatch(loginConfirmedAction(response.data.data.user));
        //
        //
        //
        //
        //return response.data;
        //return 'success';
        //history.push('/dashboard');
        navigate("/dashboard");
        return {status: "success"};
    } catch (error) {
      if (error?.response?.data?.error === "User Not Found") {
        const displayName = user.displayName?.trim() || "";
        sessionStorage.removeItem("helpclic_social_registration_profile");
        navigate("/completer-mon-profil", {
          state: {
            userInfo: {
              email: user.email,
              firstName: displayName.split(" ")[0] || "",
              lastName: displayName.split(" ").slice(1).join(" "),
              imageUri: user.photoURL || "",
            },
            signedBy,
            idToken,
          },
        });
        return {status: "registration-required"};
      }
      throw error;
    }
  };
}

export function updateProfile(data) {
  return {
    type: PROFILE_UPDATED,
    payload: data,
  };
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}
